<form [formGroup]="formGroup">
  <p-multiselect
    formControlName="companyClientsId"
    [fluid]="true"
    id="client"
    [options]="clients"
    optionLabel="name"
    optionValue="id"
    [filter]="true"
    filterBy="name"
    [showClear]="true"
    [loading]="companyClientService.isLoading()"
    [placeholder]="'calculator.placeholder.selectClient' | transloco"
    (onPanelHide)="closeAddClient()"
    data-testid="client.multi.select"
    appendTo="body"
  >
    <ng-template pTemplate="footer">
      @if (!addClientMode) {
        <div class="flex justify-between p-3">
          <p-button
            [label]="'calculator.label.addClient' | transloco"
            severity="secondary"
            text
            size="small"
            icon="pi pi-plus"
            (onClick)="showAddClient(); $event.stopPropagation()"
            data-testid="toggleAddClient"
          />
        </div>
      } @else {
        <div class="flex flex-row gap-2 p-2">
          <input
            pInputText
            [(ngModel)]="newClientName"
            [placeholder]="'companyClientList.clientName' | transloco"
            class="flex-1"
            [ngModelOptions]="{ standalone: true }"
            (click)="$event.stopPropagation()"
            #clientInput
          />
          <p-button
            (onClick)="createClient(); $event.stopPropagation()"
            icon="pi pi-user-plus"
            data-testid="addClient.button"
          ></p-button>
          <p-button
            (onClick)="closeAddClient(); $event.stopPropagation()"
            icon="pi pi-times"
            [text]="true"
            data-testid="addClient.button"
          ></p-button>
        </div>
      }
    </ng-template>
  </p-multiselect>
</form>
